export const apiConstants = {
  perPage: 8,
  perState: 8,
  defaultPage: 1,
}
